import { getAutoMonarchExperienceReturnValue, getMonarchExperienceReturnValue, formatMonarchAssets } from '../components/Cohesion/AutoMonarchCall.js';
import { logCustomAttributes, logEvent } from './logging.js';
import { debugLog } from './debugLog.js';

const handleDecisionRendering = _ref => {
  let {
    callMonarchWithPreamp,
    setRenderedDecisions,
    preampDecisions,
    monarchResponse,
    monarchAutoCallResponse,
    renderedDecisions
  } = _ref;
  debugLog('handleDecisionRendering - entered function with:', {
    renderedDecisions: renderedDecisions,
    preampDecisions: preampDecisions,
    monarchAutoCallResponse: monarchAutoCallResponse,
    monarchResponse: monarchResponse
  });
  if (typeof renderedDecisions === 'undefined' && typeof preampDecisions !== 'undefined') {
    debugLog('handleDecisionRendering - is executing, ie renderedDecisions is undefined and preampDecisions are defined');
    // callMonarchWithPreamp is not called if Preamp errors, ie preampDecisions is set to 'true'
    const enabledCallMonarchWithPreamp = typeof preampDecisions === 'object' ? Boolean(callMonarchWithPreamp(preampDecisions)) : false;
    const enabledNativeAutoCallMonarch = Boolean(window?._Cohesion?.monarch?.autoRequest?.enabled);
    const suppressMonarchAutoPlacement = Boolean(window?._Cohesion?.monarch?.autoRequest?.suppressPlacements);
    const hasNecessaryResponses = preampDecisions && enabledCallMonarchWithPreamp == Boolean(monarchResponse) && enabledNativeAutoCallMonarch == Boolean(monarchAutoCallResponse);
    debugLog(`handleDecisionRendering - hasNecessaryResponses to start to render: ${hasNecessaryResponses}`);
    if (hasNecessaryResponses) {
      const nativeAutoCallMonarchExp = getAutoMonarchExperienceReturnValue(monarchAutoCallResponse ?? {});
      const monarchExperience = getMonarchExperienceReturnValue(monarchResponse ?? {});
      let renderSource;
      if (enabledNativeAutoCallMonarch && nativeAutoCallMonarchExp && !suppressMonarchAutoPlacement) {
        const {
          assetPlacements
        } = nativeAutoCallMonarchExp;
        const formattedAssets = formatMonarchAssets(assetPlacements);
        renderSource = 'autoMonarch';
        debugLog(`handleDecisionRendering - setting rendered decision from ${renderSource}`, formattedAssets);
        setRenderedDecisions(formattedAssets);
      } else if (enabledCallMonarchWithPreamp && monarchExperience) {
        const {
          assetPlacements
        } = monarchExperience;
        const formattedAssets = formatMonarchAssets(assetPlacements);
        renderSource = 'monarch';
        debugLog(`handleDecisionRendering - setting rendered decision from ${renderSource}`, formattedAssets);
        setRenderedDecisions(formattedAssets);
      } else {
        renderSource = 'preamp';
        debugLog(`handleDecisionRendering - setting rendered decision from ${renderSource}`, preampDecisions);
        setRenderedDecisions(preampDecisions);
      }
      logCustomAttributes([{
        name: 'cohesion.renderedExperienceSource',
        value: renderSource
      }]);
      logEvent('cohesion.renderedExperience');
    }
  } else {
    debugLog('handleDecisionRendering - not rendering yet, ie renderedDecisions is defined or preampDecisions are undefined');
  }
};

export { handleDecisionRendering };
